import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import { i18n } from './plugins/i18n.js'
import apolloProvider from './utils/apollo'
import router from './router/router'
import store from './store'
require('@/assets/sass/main.scss');

Vue.config.productionTip = false

new Vue({
  vuetify,
  apolloProvider,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
